import React, { useState, useEffect } from 'react';
import './PlanningBottomUp.css';
import { useDispatch, useSelector } from 'react-redux';
import { groupBy, isEmpty } from 'lodash';
import { Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { RightsAccess, checkArray } from '../../Components/helper';
import {
  SizeRatio,
  BasicInfoTable,
  MonthlyPlanSell,
  RosStore,
  FPTable,
  MDTable,
  Terminal,
  TotalTable,
  SellThrough,
  MerchOption,
  UKRetail,
  Vat,
  LengthRatio,
  UKRetailSv,
  UnitCostRetail,
  UnitCostMoqShortFall,
} from './Tables';
import { UnitCostGlobal } from './Tables/UnitCostGlobal';
import * as bottomAction from './store/PlanningBottom.action';
import { usePlanningBottomupState } from './Context';
import Loader from '../../Components/Utility/Loader/Loader';
import { toasterMsg } from '../../Components/Toaster/Toaster';
import { ChannelTable } from './Tables/ChannelTable';
import { useComponent } from '../UserSetting/UsersLibrary/UserRights';
import FilterBottomTop from './FilterTopBottom';

function PlanningBottomUp() {
  const { CheckActionPermission, CheckModulePermission } = useComponent();
  const { t } = useTranslation('common');
  const reducer = useSelector((reducerState) => reducerState);
  const {
    Users: { logInRights },
    UserDetails: { isCompanyAdminLoggedIn },
  } = reducer;
  const { planningBottomup, setPlanningBottomup } = usePlanningBottomupState();
  const { planningBottomProducts, selectedLevel, staticPlanningBottomUpKeys, autoCalculatedObj, displayAtrributes } = planningBottomup;
  const dispatch = useDispatch();
  const [state, setState] = useState({
    isLoading: false,
    errorIndex: [],
    categoryYear: null,
    level: selectedLevel?.level || 0,
    addEditAccess: CheckActionPermission(logInRights, 'planning', 'bottomUp', 'addEdit'),
    topDownDisplay: CheckModulePermission(logInRights, 'planning', 'topDown', isCompanyAdminLoggedIn),
  });
  const [displayTables, setDisplayTables] = useState({});
  const { planningTopsDownRight } = RightsAccess();
  const { isLoading, level, addEditAccess, topDownDisplay } = state;

  // useEffect(() => {
  // if (logInRights) {
  //   const AddEditPlanningBottom = CheckActionPermission(logInRights, "planning", "bottomUp", "addEdit");
  //   const displayTopDown = CheckModulePermission(logInRights, "planning", "topDown");

  //   setState((prev) => ({
  //     ...prev,
  //     addEditAccess: AddEditPlanningBottom,
  //     topDownDisplay: displayTopDown,
  //   }));
  // }
  // // }, [logInRights]);

  const addForTableDisplay = (exist, next) => {
    return exist ? Number(exist) + next : next;
  };

  const firstFiveDisplay = (keyName, obj, addVal) => {
    if (keyName === 'fpRos' || keyName === 'stores') {
      obj.fpRosTable = addForTableDisplay(obj.fpRosTable, addVal);
    }
    if (keyName === 'fpSalesUnits' || keyName === 'fpSalesValue' || keyName === 'fpSlsMix') {
      obj.fpSalesTable = addForTableDisplay(obj.fpSalesTable, addVal);
    }
    if (keyName === 'mdSalesUnits' || keyName === 'markDown' || keyName === 'mdSalesValue' || keyName === 'mdSlsMix') {
      obj.mdTable = addForTableDisplay(obj.mdTable, addVal);
    }
    if (keyName === 'terminal' || keyName === 'terminalUnits') {
      obj.terminalTable = addForTableDisplay(obj.terminalTable, addVal);
    }
    if (keyName === 'totalUKBuyUnits' || keyName === 'totalSalesValue') {
      obj.totalTable = addForTableDisplay(obj.totalTable, addVal);
    }
    if (keyName === 'fpSellThrougn' || keyName === 'totalSellThrougn') {
      obj.SellThrough = addForTableDisplay(obj.SellThrough, addVal);
    }
    if (keyName === 'ukRetailCv' || keyName === 'ukRetailSvNet') {
      obj.UKRetail = addForTableDisplay(obj.UKRetail, addVal);
    }
  };

  useEffect(() => {
    const obj = {};
    displayAtrributes?.forEach((data) => {
      const { keyName } = data;
      const addVal = data.display ? 1 : -1;
      firstFiveDisplay(keyName, obj, addVal);
      if (keyName === 'ukRetailSvGross' || keyName === 'ukRetailMarginPer') {
        obj.UKRetailSv = addForTableDisplay(obj.UKRetailSv, addVal);
      }
      if (keyName === 'unitsRetail' || keyName === 'costRetail') {
        obj.UnitCostRetail = addForTableDisplay(obj.UnitCostRetail, addVal);
      }
      if (keyName === 'unitsGlobal' || keyName === 'costGlobal') {
        obj.UnitCostGlobal = addForTableDisplay(obj.UnitCostGlobal, addVal);
      }
      if (keyName === 'unitMOQShortfall' || keyName === 'costMOQShortfall') {
        obj.UnitCostMoqShortFall = addForTableDisplay(obj.UnitCostMoqShortFall, addVal);
      }
    });
    setDisplayTables(obj);
  }, [displayAtrributes]);

  const obj = JSON.parse(localStorage.getItem('bottomUpFilter'));
  const callFn = async () => {
    await dispatch(bottomAction.getActiveChannelList(true));
    if (!isEmpty(obj)) {
      setState((prevState) => ({ ...prevState, isLoading: true }));
      const paramsObj = {
        year: obj.year,
        season: obj.season,
        seasonText: obj.seasonText,
        categoryOne: obj.catOneId,
        loading: true,
        level: obj.level.level,
        brandId: obj.brandId,
        subBrandId: obj.subBrandId,
        productType: obj.productType,
        catOneId: obj.catOneId,
        catTwoId: obj.catTwoId,
        catThreeId: obj.catThreeId,
        catFourId: obj.catFourId,
        supplierId: obj.supplierId,
        seasonId: obj.seasonId,
        month: obj.month,
        status: obj.status,
        createdBy: obj.createdBy,
        dynamicTypes: obj.dynamicTypes,
      };

      const response = await dispatch(bottomAction.getBottomData(paramsObj));
      if (response?.errMsg) {
        toasterMsg(response.errMsg, 'danger');
        setState((prevState) => ({
          ...prevState,
          isLoading: false,
        }));
        return;
      }

      if (response) {
        setPlanningBottomup((prev) => ({
          ...prev,
          selectedLevel: obj.level,
        }));
        setState((prevState) => ({
          ...prevState,
          isLoading: false,
          level: obj.level.level,
        }));
      }
    }
  };

  useEffect(() => {
    callFn();
  }, [dispatch]);

  const getFilterData = (data) => {
    if (data?.year && checkArray(data?.categoryOne)) {
      setState((prevData) => ({
        ...prevData,
        categoryYear: data,
      }));
    } else {
      setState((prevData) => ({
        ...prevData,
        categoryYear: null,
      }));
    }
  };

  const makeGroup = async (state, groupedId) => {
    const grouped_data = groupBy(state, groupedId);
    return Object.keys(grouped_data).map(function (key) {
      return { group: key, data: grouped_data[key] };
    });
  };

  const getUniqueListBy = (arr, key) => {
    return [...new Map(arr.map((item) => [item[key], item])).values()];
  };

  const addSameData = (arr, key) => {
    const result = [];
    if (key === 'unit') {
      arr.forEach(function (a) {
        if (!this[a.colourway]) {
          this[a.colourway] = { colourway: a.colourway, value: 0, ratio: 0 };
          result.push(this[a.colourway]);
        }
        this[a.colourway].value += Number(a.value) || 0;
        if (a.value > 0) {
          this[a.colourway].ratio += Number(a.ratio) || 0;
        }
      }, Object.create(null));
    } else {
      arr.forEach(function (a) {
        if (!this[a.colourway]) {
          this[a.colourway] = { colourway: a.colourway, value: 0 };
          result.push(this[a.colourway]);
        }
        this[a.colourway].value += Number(a.value);
      }, Object.create(null));
    }
    return result;
  };

  const getChanneldata = (data) => {
    const obj = {};
    for (const keys in data) {
      data[keys].unit = [];
      data[keys].cost = [];
      obj[keys] = { ...data[keys] };
    }

    return obj;
  };
  const removeDuplicateColourWay = (data) => {
    return [
      ...new Map(
        data.map((m) => {
          delete m.value;
          return [m.colourway, m];
        }),
      ).values(),
    ];
  };
  const dataSaveFor1to4 = async () => {
    const obj = JSON.parse(localStorage.getItem('bottomUpFilter'));
    const paramsObj = {
      year: obj.year,
      season: obj.season,
      seasonText: obj.seasonText,
      categoryOne: obj.catOneId,
      loading: true,
      level: obj.level.level,
      brandId: obj.activeBrand,
      subBrandId: obj.activeSubBrand,
      productType: obj.productType,
      catOneId: obj.catOneId,
      catTwoId: obj.catTwoId,
      catThreeId: obj.catThreeId,
      catFourId: obj.catFourId,
      supplierId: obj.supplierId,
      seasonId: obj.seasonId,
      month: obj.month,
      status: obj.status,
      createdBy: obj.createdBy,
      dynamicTypes: obj.dynamicTypes,
    };
    const catDataArr = [];
    planningBottomProducts.forEach((dat) => {
      const basic = dat.basicInfo;
      if (dat.isChanged) {
        const planSelling = {
          planSelling: dat.planSelling,
          catOneId: basic?.catOneId?._id || null,
          catTwoId: basic?.catTwoId?._id || null,
          catThreeId: basic?.catThreeId?._id || null,
          catFourId: basic?.catFourId?._id || null,
        };
        catDataArr.push(planSelling);
      }
    });
    if (catDataArr?.length > 0) {
      setState((prevData) => ({
        ...prevData,
        isLoading: true,
      }));
      const sendData = {
        level: Number(level),
        filterObj: paramsObj,
        catData: catDataArr,
      };
      const res = await dispatch(bottomAction.SaveData(sendData));
      if (res) {
        await callFn();
        setState((prevData) => ({
          ...prevData,
          isLoading: false,
        }));
      }
    }
  };

  const saveChanges = async () => {
    let sendData = [];
    if (level <= 4) {
      dataSaveFor1to4();
      return;
    }
    if (level === 5) {
      sendData = planningBottomProducts.map((dat) => {
        return {
          planSelling: dat.existingPlanSelling,
          devOrderId: dat._id,
        };
      });
    } else {
      const groupsFilterData = await makeGroup(planningBottomProducts, '_id');
      groupsFilterData.forEach((filterData) => {
        const channels = getChanneldata(filterData.data[0].channels);
        const obj = {
          devOrderId: filterData.group,
          planSelling: [],
          fpRos: [],
          stores: [],
          fpSlsMix: [],
          markDown: [],
          terminal: [],
          sizeRatio: [],
          lengthRatio: [],
          fpSalesUnits: [],
          fpSalesValue: [],
          mdSalesUnits: [],
          mdSalesValue: [],
          terminalUnits: [],
          totalUKBuyUnits: [],
          ukRetailCv: [],
          ukRetailSvNet: [],
          ukRetailSvGross: [],
          unitsRetail: [],
          costRetail: [],
          costGlobal: [],
          totalSalesValue: [],
          unitsGlobal: [],
          unitMOQShortfall: [],
          costMOQShortfall: [],
          channels,
        };
        filterData.data.forEach((data) => {
          const colourway = data?.basicInfo?.colour?._id;
          autoCalculatedObj.forEach((autoKeys) => {
            obj[autoKeys].push({ colourway, value: data[autoKeys] });
          });
          staticPlanningBottomUpKeys.forEach((staticKeys) => {
            if (staticKeys === 'channels') {
              for (const channelKey in data[staticKeys]) {
                if (data[channelKey].unitType === 'manual') {
                  obj.channels[channelKey].unit.push(data[channelKey].unit);
                } else {
                  delete data[channelKey].unit.value;
                  obj.channels[channelKey].unit.push(data[channelKey].unit);
                }
                if (data[channelKey].costType === 'manual') {
                  obj.channels[channelKey].cost.push(data[channelKey].cost);
                } else {
                  delete data[channelKey].cost.value;
                  obj.channels[channelKey].cost.push(data[channelKey].cost);
                }
              }
            } else {
              obj[staticKeys].push(data[staticKeys]);
            }
          });
        });
        if (level === 6) {
          delete obj.sizeRatio;
          delete obj.lengthRatio;
        }
        if (level === 7) {
          delete obj.lengthRatio;
        }
        if (level === 8) {
          delete obj.sizeRatio;
        }
        sendData.push(obj);
      });
      if (level >= 7) {
        sendData = sendData.map((grup) => {
          grup = sameDataAddFor78(grup);
          for (const keys of autoCalculatedObj) {
            grup[keys] = addSameData(grup[keys], keys);
          }
          return grup;
        });
      }
    }
    if (checkSizeLengthValidation(sendData)) {
      setState((prevData) => ({
        ...prevData,
        isLoading: true,
      }));

      const res = await dispatch(bottomAction.SaveData(sendData));
      if (res) {
        await callFn();
        setState((prevData) => ({
          ...prevData,
          isLoading: false,
        }));
      }
    }
  };
  const channelAdd78 = (grup, key) => {
    if (key === 'channels') {
      for (const channelKey in grup.channels) {
        const unitArray = grup[key][channelKey].unit;
        const costArray = grup[key][channelKey].cost;
        if (grup[key][channelKey].costType === 'manual') {
          grup[key][channelKey].cost = addSameData(costArray, 'cost');
        } else {
          grup[key][channelKey].cost = removeDuplicateColourWay(costArray);
        }
        if (grup[key][channelKey].unitType === 'manual') {
          grup[key][channelKey].unit = addSameData(unitArray, 'unit');
        } else {
          grup[key][channelKey].unit = removeDuplicateColourWay(unitArray);
        }
      }
    }
    return grup;
  };

  const sameDataAddFor78 = (grup) => {
    const level78keys = ['fpRos', 'unitMarketPlace', 'unitOutlate'];
    for (const keys of staticPlanningBottomUpKeys) {
      if (keys === 'sizeRatio' || keys === 'lengthRatio' || keys === 'channels') {
        grup = channelAdd78(grup, keys);
      } else if (level78keys.includes(keys)) {
        grup[keys] = addSameData(grup[keys], keys);
      } else if (Array.isArray(grup[keys])) {
        grup[keys] = getUniqueListBy(grup[keys], 'colourway');
      }
    }
    return grup;
  };
  const getSizeLengthValidation = (sizeRatio) => {
    let val = 1;
    const obj = {};

    sizeRatio.forEach((siz) => {
      // Ensure siz.colourway is defined
      if (siz.colourway) {
        if (obj[siz.colourway]) {
          obj[siz.colourway].value += Number(siz.value);
        } else {
          obj[siz.colourway] = {
            colourway: siz.colourway,
            value: Number(siz.value),
          };
        }
      }
    });

    for (const valKey in obj) {
      if (obj[valKey].value < 1) {
        val = obj[valKey].value;
      }
    }

    return val;
  };

  const checkSizeLengthValidation = (sendData) => {
    let send = true;
    if (level >= 7) {
      let val = 1;
      sendData.forEach((data) => {
        if (level === 7) {
          val = getSizeLengthValidation(data.sizeRatio);
        } else {
          val = getSizeLengthValidation(data.lengthRatio);
        }
      });
      if (val < 1) {
        toasterMsg(`${level === 7 ? 'Size' : 'Length'} ${t('PLANING_BOTTOM_UP.PLANNING_BUTTOM.RATIO_NOT_LESS_THEN')}`, 'danger');
        send = false;
      }
    }
    return send;
  };

  return (
    <form>
      <div className="page-title-filter sticky">
        <div className="title-container d-flex align-items-center">
          <h4 className="title">{t('PLANING_BOTTOM_UP.PLANNING_BUTTOM.TITLE')}</h4>
        </div>
        <div className="search-filter">
          {level > 0 && (
            <span className="mr-1">
              {t('PLANING_BOTTOM_UP.PLANNING_BUTTOM.LEVEL_LABEL')} {level}
            </span>
          )}

          <FilterBottomTop filterData={(data) => getFilterData(data)} setPlanningState={setState} planningState={state} />

          {addEditAccess && (
            <>
              <button className="btn btn-white btn-back-lib ml-2 d-none d-md-flex" type="button" onClick={saveChanges}>
                <i className="icon-Save mr-1" />
                {t('PLANING_BOTTOM_UP.PLANNING_BUTTOM.SAVE')}
              </button>
              <button className="filter-btn  ml-2 d-md-none" type="button" onClick={saveChanges}>
                <i className="icon-Save f-16" />
              </button>
            </>
          )}
          <Link
            className="cursor-pointer text-dark text-decoration-none btn btn-white btn-back-lib ml-2 d-none d-md-block"
            to="/planning/planning-bottomup/channel-setting"
          >
            {t('PLANING_BOTTOM_UP.PLANNING_BUTTOM.CHANNEL_SETTINGS')}
          </Link>
          <Link className="cursor-pointer text-dark text-decoration-none filter-btn ml-2 d-md-none" to="/planning/planning-bottomup/channel-setting">
            <i className="icon-settings f-16" />
          </Link>
        </div>
      </div>

      <Container fluid className="d-flex justify-content-end  mt-3 mb-4">
        {topDownDisplay && planningTopsDownRight && (
          <Link className="cursor-pointer text-dark text-decoration-none btn btn-page-filter" to="/planning/planning-actual">
            {t('PLANING_BOTTOM_UP.PLANNING_BUTTOM.TOP_DOWN')}
          </Link>
        )}
        {planningBottomup?.BottomUpDisplay && (
          <Link className="cursor-pointer text-dark text-decoration-none btn-active btn btn-page-filter" to="/planning/planning-bottomup">
            {t('PLANING_BOTTOM_UP.PLANNING_BUTTOM.BUTTOMS_UP')}
          </Link>
        )}
      </Container>

      {!isLoading ? (
        <div className="overflow-auto pt-0 px-3 pb-3" style={{ height: 'calc(100vh - 230px)' }}>
          <div className="d-flex compare-tbl-container">
            <BasicInfoTable />
            <MonthlyPlanSell />
            {displayTables?.fpRosTable !== -2 && <RosStore />}
            {displayTables?.fpSalesTable !== -3 && <FPTable />}
            {displayTables?.mdTable !== -4 && <MDTable />}
            {displayTables?.terminalTable !== -2 && <Terminal />}
            {displayTables?.totalTable !== -2 && <TotalTable />}
            {displayTables?.SellThrough !== -2 && <SellThrough />}
            {level === 7 && <SizeRatio />}
            {level === 8 && <LengthRatio />}
            <MerchOption />
            {displayTables?.UKRetail !== -2 && <UKRetail />}
            {level >= 5 && <Vat />}
            {displayTables?.UKRetailSv !== -2 && <UKRetailSv />}
            {displayTables?.UnitCostRetail !== -2 && <UnitCostRetail />}
            <ChannelTable />
            {displayTables?.UnitCostGlobal !== -2 && <UnitCostGlobal />}
            {displayTables?.UnitCostMoqShortFall !== -2 && <UnitCostMoqShortFall />}
          </div>
          {planningBottomProducts?.length < 1 && <div className="center-text-table">{t('PLANING_BOTTOM_UP.PLANNING_BUTTOM.NO_RECORDS_FOUND')}</div>}
        </div>
      ) : (
        <Loader />
      )}
    </form>
  );
}

export default PlanningBottomUp;
